import { useState } from 'react';
import { getToken, updateToken } from '../../services/tokenService';

/** Like useLocalStorage for the auth keys, but in the storage tokenService picks (sessionStorage in an impersonation tab). */
export const useAuthStorage = (keyName, defaultValue) => {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            return getToken(keyName) ?? defaultValue;
        } catch (error) {
            return defaultValue;
        }
    });

    const setValue = newValue => {
        try {
            updateToken(keyName, newValue);
        } catch (error) {}
        setStoredValue(newValue);
    };

    return [storedValue, setValue];
};
